<div class="bg music"
     [class.filled]="muted()">
</div>